module.exports = __webpack_public_path__ + "img/Gruppenführer_Öl.f9b316a2.svg";